// src/pages/pedidos/StatusCard.js
import React from 'react';
import { FaClipboardList, FaTools, FaShoppingBag, FaCheckCircle } from 'react-icons/fa';

const statusIcons = {
  'Em análise': <FaClipboardList size={30} />,
  'Em Produção': <FaTools size={30} />,
  'Aguardando Retirada/Entrega': <FaShoppingBag size={30} />,
  'Concluído': <FaCheckCircle size={30} />
};

const StatusCard = ({ status, color, count }) => {
    return (
      <div className={`status-card ${color}`}>
        <div className="card-header">
          <div className="card-icon" aria-hidden="true">
            {statusIcons[status]}
          </div>
          <div className="card-info">
            <h3>{status}</h3>
          </div>
          <span className="status-count" aria-label={`${count} pedidos`}>{count}</span>
        </div>
      </div>
    );
  };
  

export default StatusCard;
